/** The rail a comms message travelled on. */
export type CommsChannel = "email" | "sms" | "chat" | "slack" | "other";

const COMMS_CHANNEL_BY_PROVIDER: Record<string, CommsChannel> = {
  agent_email: "email",
  mailgun: "email",
  gmail: "email",
  microsoft_graph: "email",
  imap: "email",
  smtp: "email",
  twilio: "sms",
  agent_thread: "chat",
  instant_message: "slack",
};

/**
 * Classifies a comms provider into the rail it belongs to, so the UI can pick a
 * renderer without enumerating every provider. Unknown providers fall back to
 * `"other"`, which the UI treats like a plain message.
 * @param provider - The comms message `provider` value
 * @returns The channel the provider belongs to
 */
export const commsChannelForProvider = (provider: string): CommsChannel =>
  COMMS_CHANNEL_BY_PROVIDER[provider] ?? "other";
